import React from 'react'
import { useParams } from 'react-router-dom'
import OptionSelectionContent from './OptionSelectionContent'
import usePricelist from '../../../hooks/usePricelist'
import Spinner from '../../Spinner'
import styles from './OptionSelection.module.sass'

const OptionSelection = () => {
  const { package_id: packageId } = useParams()
  const { data: pkg, isLoading } = usePricelist(packageId)

  // Derive the addon audience from the PACKAGE, not the component default
  // (which is elementary). Without this, a senior package routed through the
  // generic /option_selection page showed elementary add-ons — e.g. the $19.95
  // "(1) High Resolution Digital File" instead of the $75 senior Digital File
  // (order 511677). Show the same spinner OptionSelectionContent would while the
  // package loads, rather than a blank container.
  if (isLoading || !pkg) {
    return (
      <div className={styles.container}>
        <Spinner color="blue" />
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <OptionSelectionContent packageId={packageId} isElementary={!pkg.isSeniorPortraits} />
    </div>
  )
}

export default OptionSelection
